// import {InsuranceGroup} from "./insurance_group";

export class Group {
  static INSURANCE = 1;
  static ASSISTANCE = 2;
  static MEDICAL = 3;
  static TELEDOCTOR = 4;
  static MEDICAL_ICD = 5;
  static MEDICAL_CPT = 6;
  static ASSISTANCE_CASE_SURVEY = 7;
  static ASSISTANCE_CASE_DISPATCHER_SURVEY = 8;
  static ASSISTANCE_CASE_TELEDOCTOR_SURVEY = 9;
  static ASSISTANCE_CASE_TELEDOCTOR_SURVEY_VIDEO = 10
  static ASSISTANCE_CASE_TELEDOCTOR_SURVEY_CHAT = 11
  static ASSISTANCE_CASE_TELEDOCTOR_SURVEY_OMT = 12
  static ASSISTANCE_CASE_CABIN_SURVEY = 13
  static ASSISTANCE_CASE_DISPATCH_SURVEY = 14
  static ASSISTANCE_CASE_COMPLETE_SURVEY = 15
  static ASSISTANCE_CASE_INFORMATION_SURVEY = 26
  static ASSISTANCE_CASE_CABIN_SURVEY_AMBULANCE = 27
  static ASSISTANCE_CASE_DISPATCH_SURVEY_AMBULANCE = 28
  static ASSISTANCE_CASE_COMPLETE_SURVEY_AMBULANCE = 29
  static STATUS_ACTIVE = 1;
  static STATUS_INACTIVE = 2;
  static ASSISTANCE_CASE_TELEDOCTOR_SURVEY_OMT_Odonto = 32;
  static ASSISTANCE_CASE_TELEDOCTOR_SURVEY_OMT_Psico = 33;

  static STATUS_TEXT = {
    1: 'Active',
    2: 'Inactive'
  }

  id: number;
  name: string;
  description: string;
  group_type: number;
  status: number;
  is_new: boolean;
  // insurance_group: InsuranceGroup;
}
